import { render } from "./ResumeConfig.vue?vue&type=template&id=58478a38&scoped=true"
import script from "./ResumeConfig.vue?vue&type=script&lang=js"
export * from "./ResumeConfig.vue?vue&type=script&lang=js"

import "./ResumeConfig.vue?vue&type=style&index=0&id=58478a38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58478a38"]])

export default __exports__